<template>
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5 4.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM1.916 11.938A12.95 12.95 0 0 1 9.5 9.5c1.096 0 2.161.136 3.179.392A5.152 5.152 0 0 0 9.919 18.5H2.5a1 1 0 0 1-1-1v-4.75a1 1 0 0 1 .416-.812ZM9.5 15a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Zm1.5 0a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Z" />
    </svg>
</template>
